import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

export const MenuItem = styled(ButtonPlain)`
	align-items: center;
	background-color: transparent;
	border: 0;
	border-radius: 4px;
	color: ${helpers.color.text};
	display: flex;
	font-size: ${helpers.font.size.base};
	gap: 12px;
	height: auto;
	justify-content: flex-start;
	margin: 0;
	min-width: 0;
	padding: 10px 12px;
	text-align: left;
	width: 100%;

	&:is(:focus-visible, :hover):not(:disabled) {
		background-color: ${({ theme }) => transparentize(0.92, theme.color.primary)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.disabled};
	}

	> svg {
		flex-shrink: 0;
	}
`
